import styled from 'styled-components';

import { flexStart } from '../../../style/reusableStyle';

export const ViewContractContainerStyled = styled.div`
  margin: 18px 0px 0px;
  max-width: 100%;

  & .title-header {
    margin-bottom: 20px;
  }
  & .contents {
    margin-left: 30px;
  }
  & .heading {
    margin-bottom: 30px;
    max-width: 800px;
    display: flex;
    justify-content: space-between;
  }
  & .profile {
    display: flex;
    /* align-items: center; */
    gap: 10px;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  /* margin-bottom: 20px; */
  & .title {
    width: 165px;
    color: ${({ theme }) => theme.colors.darkText};
    flex-shrink: 0;
  }
  & .value {
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;

    & .title {
      font-weight: 600;
    }
  }
`;

export const ActionsContainer = styled.div`
  ${flexStart};
  gap: 24px;
  margin-top: 20px;
`;
